import "./MySelect.css"
import { define_doc_object } from "../../Pages/SendDocs/SendNewDoc";
import FormDocMetadata from "../../Model/FormDocMetadata";

interface MySelectProps {
    title: string;
    options: string[];
    sendDocForm: boolean;
    simpleForm?: boolean;
    setOption?: React.Dispatch<React.SetStateAction<string>>;
    setDoc?: React.Dispatch<React.SetStateAction<{[k: string]: any;}>>;
    name?: string;
    documentMetaList?: FormDocMetadata[];
    doc?: {
        [k: string]: any;
    }
}

export default function MySelect (props: MySelectProps) {
    const HandleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (props.sendDocForm) {
            props.setDoc!(define_doc_object(props.documentMetaList!, props.name!, event.target.value, props.doc!, false));
        }
        else {
            props.setOption!(event.target.value);
        }
    }

    if(props.simpleForm){

        return (
            <select className="form-select" onChange={HandleChange}>
                {props.options.map((option, index) => {
                    return (
                        <option key={index}>{option}</option>
                    )
                })}
            </select>
        )
    }
    else
    {
        return (
            <div className="MySelect">
                <div>{props.title}</div>
                <select className="form-select" onChange={HandleChange}>
                    {props.options.map((option, index) => {
                        return (
                            <option key={index}>{option}</option>
                        )
                    })}
                </select>
            </div>
        )
    }
}